export const sortFilterByValue = (filter) => {
  filter.sort((c1, c2) => c1.value.toString().toLowerCase() > c2.value.toString().toLowerCase() ? 1 : -1);
};

export const generateCategoryHierarchy = (categories) => {
  const map = {};
  const roots = [];

  // Initialize map and children arrays
  const updatedCategories = categories.map((category, idx) => {
    map[category.key] = idx;
    return {
      ...category,
      children: [],
    };
  });

  updatedCategories.forEach((category) => {
    if (category.parent !== null) {
      const { children } = updatedCategories[map[category.parent]];
      children.push(category);
      sortFilterByValue(children);
    } else {
      roots.push(category);
    }
  });

  sortFilterByValue(roots);
  return roots;
};

export const getAllDescendantKeys = (allCategories, value, descendantKeys) => {
  const childrenKeys = allCategories.filter(category => category.parent === value).map(category => (category.key));
  if (childrenKeys.length === 0) {
    return descendantKeys;
  }
  descendantKeys.push(...childrenKeys);
  childrenKeys.forEach(childKey => getAllDescendantKeys(allCategories, childKey, descendantKeys));
  return descendantKeys;
};
